import { Injectable, signal } from '@angular/core';

/** Lets a component skip the next canDeactivate check for an intentional
 * navigation (e.g. after deleting the very record the "unsaved changes"
 * guard would otherwise ask about). */
@Injectable({ providedIn: 'root' })
export class NavigationGuardBypassService {
  private readonly bypass = signal(false);

  requestBypass(): void {
    this.bypass.set(true);
  }

  consumeBypass(): boolean {
    const value = this.bypass();
    this.bypass.set(false);
    return value;
  }
}
